import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './ImportantCirculars.css';
import './Schemes.css'; // Import schemes CSS for table styles

// Circulars Table Component
export const CircularsTable = () => {
  const { isMarathi } = useLanguage();

  return (
    <section className="circulars-section">
      <div className="circulars-table-container">
        <table className="circulars-table">
          <thead>
            <tr>
              <th>
                {isMarathi() ? 'अनुक्रमांक' : 'Serial No.'}
              </th>
              <th>
                {isMarathi() ? 'परिपत्रकाचे नाव' : 'Circular Name'}
              </th>
              <th>
                {isMarathi() ? 'परिपत्रक' : 'Circular'}
              </th>
              <th>
                {isMarathi() ? 'तारीख' : 'Date'}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '१' : '1'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'दिव्यांग व्यक्तींना द्यावयाच्या सवलतीबाबत' : 'Regarding concessions to be given to persons with disabilities'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/concetion_for_divyang_paripatrak_22112019.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '२६/०७/२०११' : '26/07/2011'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '२' : '2'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'ग्रंथालय वाचन साहित्य रद्दबातल धोरण सुधारणा - दिनांक २०/१२/२०१६ व दिनांक १४/०६/२०१८' : 'Library Reading Material Cancellation Policy Amendment'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/granthalay_vachan_sahitya_raddabatal_dhoran_sudharana_17102019.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '२०/१२/२०१६ व १४/०६/२०१८' : '20/12/2016 and 14/06/2018'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '३' : '3'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'मंडळाच्या कार्याच्या प्रचार-प्रसाराबाबत' : 'Regarding the promotion and dissemination of the Board\'s activities'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/mandalachya_karyacha_prachar_prasarababat_10042019.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '१०/०४/२०१९' : 'April 10, 2019'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '४' : '4'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'अपुर्ण, त्रुटीयुक्त, नियमबाह्य अर्ज न स्विकारण्याबाबत' : 'Regarding not accepting incomplete, defective, and irregular applications'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/apurna_trutiyuktta_niyambahya_arja_na_swikarnebabat_10042019.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '१०/०४/२०१९' : 'April 10, 2019'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '५' : '5'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'ग्रंथालय वाचनसाहित्य रद्दबादल धोरण सुधारणा' : 'Library Reading Material Cancellation Policy Amendment'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/granthalay_vachan_sahitya_raddbadal_dhoran_sudharana_23072014.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '२३/०७/२०१४' : '23.07.2014'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '६' : '6'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'ग्रंथालय वाचनसाहित्य रद्दबादल धोरण' : 'Library Reading Material Cancellation Policy'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/granthalay_vachan_sahitya_raddbadal_dhoran_19102013.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '१९/१०/२०१३' : '19.10.2013'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '७' : '7'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'प्रतिसाद नसलेले केंद्र बंद करणेबाबत' : 'Regarding closing down centers with no response'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/centre_close_letter_and_list_18022019.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '-' : 'NA'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '८' : '8'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'ग्रंथालय वृत्तपत्र खरेदी' : 'Library newspaper purchase'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/Granthalay_vruttapatra_kharedi.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '-' : 'NA'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '९' : '9'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'दिवाळी अंक खरेदी' : 'Diwali special issue purchase'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/Diwali_ank_kharedi.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '-' : 'NA'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '१०' : '10'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'कामगारास दाखला देणेबाबत' : 'Regarding issuing certificates to workers'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/Kamgaras_dakhala_denebabat.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '-' : 'NA'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '११' : '11'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'शासकीय ई मेलचा वापर' : 'Use of government email'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/Shasakiy_emailcha_vapar.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '-' : 'NA'}
              </td>
            </tr>
            
            <tr>
              <td className="circular-serial">
                {isMarathi() ? '१२' : '12'}
              </td>
              <td className="circular-details">
                {isMarathi() ? 'अभ्यासिका सुरु करणेबाबत' : 'Regarding starting study centers'}
              </td>
              <td className="circular-more-info">
                <a 
                  href="https://mlwb.in/react-static-files/pdf/homepage/Important-Circulars/Abhyasika_suru_karanebabat.pdf" 
                  className="circular-link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="circular-date">
                {isMarathi() ? '-' : 'NA'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};

const ImportantCirculars = () => {
  usePageSearchIndex({
    mr: ['महत्वाची परिपत्रके', 'परिपत्रक', 'मैदान आरक्षण', 'शुल्क'],
    en: ['important circulars', 'circular', 'ground reservation', 'fees']
  });

  const pageHeaderData = {
    title: {
      marathi: 'महत्वाची परिपत्रके',
      english: 'Important Circulars'
    },
    subtitle: {
      marathi: 'महाराष्ट्र कामगार कल्याण मंडळाची महत्वाची परिपत्रके',
      english: 'Important Circulars of Maharashtra Labour Welfare Board'
    }
  };

  return (
    <div className="important-circulars-container">
      <PageHeader 
        title={pageHeaderData.title}
        subtitle={pageHeaderData.subtitle}
      />
      
      <div className="important-circulars-content">
        <CircularsTable />
      </div>
    </div>
  );
};

export default ImportantCirculars;

